import { useState } from "react";
import { Empty, BlockHead, Chips, ExpandTable, Selo, MiniBar, Detalhe } from "../../components/primitives";
import { STATUS_CFG } from "./FluxoMedClientes";

const CHECKLIST_PIPELINE = [
  { id: "convenios",         label: "Convênios"       },
  { id: "unidades",          label: "Unidades"        },
  { id: "mensagens_core",    label: "Mensagens"       },
  { id: "followup_config",   label: "Follow-up"       },
  { id: "sandbox_teste",     label: "Exportação JSON" },
  { id: "fluxo_completo",    label: "Teste WhatsApp"  },
  { id: "secretaria_alerta", label: "Teste Evolution" },
  { id: "cliente_aprovado",  label: "Produção"        },
];

const HOM_STATUS_CFG = {
  pendente:  { label: "Pendente",  tone: "warn" },
  aprovado:  { label: "Aprovado",  tone: "ok"   },
  reprovado: { label: "Reprovado", tone: "bad"  },
};

const FILTROS = ["todos", "pendente", "aprovado", "reprovado"];

function feitos(checklist) {
  const saved = Array.isArray(checklist) ? checklist : [];
  return CHECKLIST_PIPELINE.map((item) => ({ ...item, ok: !!saved.find((s) => s.id === item.id && s.ok) }));
}

export function FluxoMedHomologacaoView({ clientes, onOpen }) {
  const [filtro, setFiltro] = useState("todos");

  const counts = {
    todos:     clientes.length,
    pendente:  clientes.filter((c) => c.homologacao_status === "pendente" || !c.homologacao_status).length,
    aprovado:  clientes.filter((c) => c.homologacao_status === "aprovado").length,
    reprovado: clientes.filter((c) => c.homologacao_status === "reprovado").length,
  };

  const filtrados = clientes.filter((c) => {
    if (filtro === "todos") return true;
    if (filtro === "pendente") return !c.homologacao_status || c.homologacao_status === "pendente";
    return c.homologacao_status === filtro;
  });

  const FILTRO_LABEL = { todos: "Todos", pendente: "Pendente", aprovado: "Aprovado", reprovado: "Reprovado" };

  return (
    <div className="view" style={{ paddingTop: 0 }}>
      <BlockHead title="Homologação" sub="Validação de cada cliente antes da produção. Abra a linha para ver o checklist." />

      <div className="tab-bar">
        <Chips
          label="Filtrar homologação"
          active={filtro}
          onChange={setFiltro}
          items={FILTROS.map((f) => ({ id: f, label: FILTRO_LABEL[f], count: counts[f] }))}
        />
      </div>

      {clientes.length === 0 ? (
        <Empty icon="✓" text="Nenhum cliente cadastrado." />
      ) : (
        <ExpandTable
          minWidth={700}
          rows={filtrados}
          empty={`Nenhum cliente com status ${filtro}.`}
          columns={[
            { key: "nome", label: "Cliente", render: (c) => {
              const sCfg = STATUS_CFG[c.status] || STATUS_CFG.rascunho;
              return <div><div className="name">{c.nome}</div><div className="sub">{sCfg.label}</div></div>;
            } },
            { key: "hom", label: "Homologação", render: (c) => {
              const h = HOM_STATUS_CFG[c.homologacao_status] || HOM_STATUS_CFG.pendente;
              return <Selo tone={h.tone}>{h.label}</Selo>;
            } },
            { key: "check", label: "Checklist", render: (c) => {
              const it = feitos(c.homologacao_checklist);
              return <MiniBar done={it.filter((i) => i.ok).length} total={it.length} />;
            } },
            { key: "resp", label: "Responsável", render: (c) => (
              <span className="sub">
                {c.homologacao_responsavel || "—"}
                {c.homologacao_data ? ` · ${new Date(c.homologacao_data).toLocaleDateString("pt-BR")}` : ""}
              </span>
            ) },
          ]}
          detail={(c) => (
            <div className="detail-grid">
              <div className="klist">
                {feitos(c.homologacao_checklist).map((item) => (
                  <div key={item.id} className={`klist-row${item.ok ? " done" : ""}`}>
                    <span className={`kcheck${item.ok ? " on" : ""}`} aria-hidden="true" style={{ cursor: "default" }}>{item.ok && "✓"}</span>
                    <span className="txt">{item.label}</span>
                  </div>
                ))}
              </div>
              <Detalhe label="Observações" pre>{c.homologacao_notas}</Detalhe>
              <div className="detail-actions">
                <button type="button" className="btn btn-primary btn-sm" onClick={() => onOpen(c.id)}>Abrir ficha</button>
              </div>
            </div>
          )}
        />
      )}
    </div>
  );
}
